import React, { useCallback, useEffect } from "react";
import { Box, Typography, Grid, Chip } from "@mui/material";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

// Constants
import { darkBlue } from "../../constants/ColourConstants";
import { formatTimeWithPeriod } from "../Common/FormatTime";
import CustomButton from "../../constants/CustomButton";

const style = {
  typographyButton: {
    color: darkBlue,
    fontSize: 16,
    fontWeight: "bold",
    fontFamily: "Arial",
    textAlign: "center",
  },
};

const gridStyles = {
  ".MuiDataGrid-columnHeaders": {
    color: darkBlue,
    fontSize: 17,
  },
  "& .MuiTablePagination-displayedRows": {
    margin: "0 !important",
  },
};

function PastAppointments() {
  const cutOffDate = moment().format("2023-06-30");
  const navigate = useNavigate();
  const { state } = useLocation();
  const appointments = state?.patientAppointments || [];

  const columns = [
    {
      field: "date",
      headerName: "Date/Time",
      minWidth: 250,
      flex: 1,
      valueGetter: (params) => {
        return `${params.row.date} @ ${formatTimeWithPeriod(
          params.row.startTime
        )}`;
      },
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 150,
      flex: 1,
      renderCell: (params) => {
        const appointment = params.row;
        const arrived = appointment.appointmentDetails?.arrived;
        const isMissedPaymentRequired = state.unpaidAppointments.includes(
          appointment.id
        );
        const isArrivedOrBeforeCutoff =
          arrived || appointment.date < cutOffDate;
        if (isArrivedOrBeforeCutoff) {
          return <Chip color="success" label="Completed" />;
        } else if (state.paidAppointments.includes(appointment.id)) {
          return (
            <Chip color="success" label="Paid No-show Fee" variant="outlined" />
          );
        } else if (isMissedPaymentRequired) {
          return <Chip color="error" label="Missed Appointment" />;
        } else {
          return <Chip color="warning" label="In progress" />;
        }
      },
    },
    {
      field: "type",
      headerName: "Type",
      minWidth: 250,
      flex: 1,
      valueGetter: () => "In-person appointment",
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const getRowSpacing = useCallback((params) => {
    return {
      top: params.isFirstVisible ? 0 : 7,
      bottom: params.isLastVisible ? 0 : 7,
    };
  }, []);

  return (
    <Box sx={{ margin: "1rem" }}>
      <Typography variant="h2" sx={style.typographyButton}>
        Appointment History
      </Typography>
      <div style={{ height: 650, width: "100%", padding: "1%" }}>
        <DataGrid
          components={{
            Toolbar: GridToolbar,
          }}
          sx={gridStyles}
          getRowId={(row) => row.appointmentId}
          getRowSpacing={getRowSpacing}
          rows={appointments}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5]}
        />
      </div>
      <Grid item xs={6}>
        <CustomButton
          label="Back"
          onClick={() => navigate("/")}
          type="secondary"
        />
      </Grid>
    </Box>
  );
}

export default PastAppointments;
